'use client';

import * as React from 'react';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import type { CultivCopy } from '../types';
// import { PlayIcon } from './icons';
import { Cap } from './Cap';
import { MARKETING_CDN, demoHref, cultivPath, loginHref } from '../site';
import { LangSwitchMenu, LangSwitchInline } from './LangSwitch';

export function SiteNav({ copy, locale }: { copy: CultivCopy; locale: string }) {
  const [open, setOpen] = React.useState(false);
  const pathname = usePathname() || '';
  const common = copy.common;
  const base = cultivPath(locale);
  const links: [string, string][] = [
    [common.navProducts, cultivPath(locale, '/platform')],
    [common.navCustomers, cultivPath(locale, '/customers')],
  ];
  const isActive = (href: string) => pathname.startsWith(href);
  const logo = `${MARKETING_CDN}/cultiv-lockup-orange-symbol.svg`;

  return (
    <div className="b-topbar">
      <nav className="b-nav">
        {/* Intercom-style split: logo + page links grouped LEFT, actions right */}
        <div className="b-nav-left">
          <Link className="b-nav-logo-link" href={base}>
            {/* eslint-disable-next-line @next/next/no-img-element */}
            <img className="b-nav-logo" src={logo} alt="Cultiv" />
          </Link>
          <div className="b-nav-mid">
            {links.map(([label, href]) => (
              <Link key={href} href={href} className={isActive(href) ? 'active' : undefined}>
                <Cap>{label}</Cap>
              </Link>
            ))}
          </div>
        </div>
        <div className="b-nav-right">
          <LangSwitchMenu locale={locale} label={common.langAria} />
          <a className="b-nav-login" href={loginHref(locale)}>{common.login}</a>
          {/* Product tour hidden until the page is finished.
          <Link className="b-nav-watch" href={watchDemoHref(locale)}>
            <PlayIcon size={13} /> {copy.watch.cta}
          </Link>
          */}
          <Link className="b-btn dark b-nav-demo" href={demoHref(locale)}><Cap>{common.demoCta}</Cap></Link>
          <button
            className={'b-nav-burger' + (open ? ' open' : '')}
            aria-label={common.menuAria}
            aria-expanded={open}
            aria-controls="b-nav-mobile"
            onClick={() => setOpen((o) => !o)}
          >
            <span /><span /><span />
          </button>
        </div>
        {open && (
          <div className="b-nav-mobile" id="b-nav-mobile">
            {links.map(([label, href]) => (
              <Link key={href} href={href} onClick={() => setOpen(false)}>{label}</Link>
            ))}
            <a href={loginHref(locale)} className="muted">{common.login}</a>
            {/* Product tour hidden until the page is finished.
            <Link className="b-nav-watch" href={watchDemoHref(locale)} onClick={() => setOpen(false)}>
              <PlayIcon size={13} /> {copy.watch.cta}
            </Link>
            */}
            <Link className="b-btn dark" href={demoHref(locale)} onClick={() => setOpen(false)}>{common.demoCta}</Link>
            <LangSwitchInline locale={locale} className="b-nav-mobile-lang" />
          </div>
        )}
      </nav>
    </div>
  );
}
